import { render, staticRenderFns } from "./Contrato.vue?vue&type=template&id=33fb8abb&scoped=true&"
import script from "./Contrato.vue?vue&type=script&lang=js&"
export * from "./Contrato.vue?vue&type=script&lang=js&"
import style0 from "./Contrato.vue?vue&type=style&index=0&id=33fb8abb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33fb8abb",
  null
  
)

export default component.exports